import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit } from '@angular/core';
import { GenericCarouselLayout } from '../../../common';
import { ImgQuery } from '../../services';
import { AbstractNavigationService } from '../../services/abstract-navigation.service';
import { getImgQueryByCarouselLayout } from '../../utils';
import { GenericCarouselItemViewModel } from './generic-carousel-item.view-model';

@Component({
  selector: 'osn-shared-generic-carousel-item',
  templateUrl: './generic-carousel-item.component.html',
  styleUrls: ['./generic-carousel-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericCarouselItemComponent implements OnInit {
  @Input() public vm!: GenericCarouselItemViewModel;
  @Input() public aspectRatio: string;
  @Input() public layout: GenericCarouselLayout;
  @Input() public readonlyMode = false; // readonlyMode is for cxb preview feature
  @HostBinding('attr.aria-label') public get ariaLabel(): string {
    return this.vm.titleToDisplay;
  }
  public imgQuery: ImgQuery;

  constructor(private readonly navigation: AbstractNavigationService) {}

  public get routerLink(): string {
    if (this.readonlyMode) {
      return undefined;
    }
    if (this.vm.pageSlug) {
      return this.navigation.getUrl('page', this.vm.pageSlug);
    }
    if (this.vm.feedUrl) {
      return this.navigation.getUrl('browseWithTitle', this.vm.containingPageSlug, this.vm.pageItemSlug, this.vm.titleSlug);
    }
    if (this.vm.genre) {
      return this.navigation.getUrl('browseGenre', this.vm.genre);
    }
  }

  public ngOnInit() {
    this.imgQuery = getImgQueryByCarouselLayout(this.layout);
  }
}
